export default __webpack_public_path__ + "c2d9623aa5b451e2a29651a002a5bfcb.png";